import { Shield, MapPin, DollarSign, Users, Clock, Zap, Lock, HeartHandshake } from 'lucide-react';

export const Benefits = () => {
  const benefits = [
    {
      icon: Lock,
      title: 'Exclusive Territories',
      description: 'Your service area is yours alone. We never share your territory with competitors, ensuring every lead is exclusively yours.',
    },
    {
      icon: DollarSign,
      title: 'Pay Per Appointment',
      description: 'Only pay for actual booked appointments with qualified homeowners. No wasted spend on clicks, impressions, or cold leads.',
    },
    {
      icon: Users,
      title: 'Pre-Qualified Leads',
      description: 'Every appointment is with a homeowner who has expressed genuine interest and is ready to discuss their project.',
    },
    {
      icon: MapPin,
      title: 'Local Targeting',
      description: 'Reach homeowners in your specific service area with precision targeting based on location and project intent.',
    },
    {
      icon: Clock,
      title: 'Same-Week Appointments',
      description: 'Get appointments scheduled within days, not weeks. Our rapid response system ensures hot leads don\'t go cold.',
    },
    {
      icon: Shield,
      title: 'Quality Guarantee',
      description: 'We stand behind our appointments. If a lead doesn\'t meet our quality standards, you don\'t pay.',
    },
    {
      icon: Zap,
      title: 'No Long-Term Contracts',
      description: 'Flexible month-to-month partnerships. We earn your business every single month through results.',
    },
    {
      icon: HeartHandshake,
      title: 'Dedicated Support',
      description: 'Work with a dedicated account manager who understands your business and helps optimize your results.',
    },
  ];

  return (
    <section className="py-20 md:py-32 bg-[#f8fafc]" data-testid="benefits-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-sm tracking-wide uppercase font-semibold text-[#2563eb] mb-4">
            Why Choose RenoNovo
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0f172a] tracking-tight mb-6">
            Built Different. Built for Results.
          </h2>
          <p className="text-lg text-[#64748b] leading-relaxed">
            We're not a traditional marketing agency. We're your growth partner, focused exclusively on 
            delivering measurable results for home service contractors.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit, index) => (
            <div
              key={benefit.title}
              data-testid={`benefit-${index}`}
              className="bg-white p-8 border border-[#e2e8f0] hover:border-[#2563eb]/30 rounded-sm transition-all duration-300 hover:shadow-[0_12px_24px_rgba(15,23,42,0.08)] group"
            >
              <div className="w-14 h-14 bg-[#2563eb]/10 rounded-sm flex items-center justify-center mb-6 group-hover:bg-[#2563eb]/20 transition-colors duration-300">
                <benefit.icon className="w-7 h-7 text-[#2563eb]" />
              </div>
              <h3 className="text-lg font-bold text-[#0f172a] mb-3">{benefit.title}</h3>
              <p className="text-[#64748b] text-sm leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
